module.exports = __webpack_public_path__ + "a3aa4c389704e264a9f5b88ec8d748ed.png";